import { render } from "./orchestra-roster.vue?vue&type=template&id=23085c67"
import script from "./orchestra-roster.vue?vue&type=script&lang=js"
export * from "./orchestra-roster.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__